import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../store";
import {
  editRequest,
  getRequestById,
  downloadFile,
  sendRequest,
} from "../modules/actions";
import { getInsurances } from "../../Insurance/modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    loadingSave: state.offerRequestReducer.loadingSave,
    loadingSend: state.offerRequestReducer.loadingSend,
    currentOfferRequest: state.offerRequestReducer.currentOfferRequest,
    currentOfferRequestSent: state.offerRequestReducer.currentOfferRequestSent,
    insurances: state.insuranceReducer.insurances,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getRequestById,
      editRequest,
      downloadFile,
      sendRequest,
      getInsurances,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
